import { defineMessages } from "react-intl";

const PREFIX = "WeekSelectorControl";
const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
    defaultMessage: "Base for index calculation",
  },
});

export default messages;
